export default {
  basic: () => import("/usr/code/docker/www/formx/client/layouts/basic.vue").then(m => m.default || m),
  default: () => import("/usr/code/docker/www/formx/client/layouts/default.vue").then(m => m.default || m)
}